export default __webpack_public_path__ + "static/media/social-twitter.a56dbc2d.svg";